// extracted by mini-css-extract-plugin
export default {"modalOverlay":"GN-z","modalContent":"HN-z","header":"IN-z","close":"JN-z"};